import { render, staticRenderFns } from "./OutProcessingPage.vue?vue&type=template&id=185615a2&"
import script from "./OutProcessingPage.vue?vue&type=script&lang=ts&"
export * from "./OutProcessingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185615a2')) {
      api.createRecord('185615a2', component.options)
    } else {
      api.reload('185615a2', component.options)
    }
    module.hot.accept("./OutProcessingPage.vue?vue&type=template&id=185615a2&", function () {
      api.rerender('185615a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/OutProcessingPage.vue"
export default component.exports